export const MY_INCIDENTS_ICONS = [
  {
    text: "Conflict",
    value: "conflict",
    fileName: "myIncidents/conflict.png",
  },
  {
    text: "Crime",
    value: "crime",
    fileName: "myIncidents/crime.png",
  },
  {
    text: "Disasters",
    value: "disasters",
    fileName: "myIncidents/disasters.png",
  },
  {
    text: "Health",
    value: "health",
    fileName: "myIncidents/health.png",
  },
  {
    text: "Organized Crime",
    value: "organized crime",
    fileName: "myIncidents/toc.png",
  },
  {
    text: "Terrorism",
    value: "terrorism",
    fileName: "myIncidents/terrorism.png",
  },
  {
    text: "Transportation",
    value: "transportation",
    fileName: "myIncidents/transportation.png",
  },
  {
    text: "Travel",
    value: "travel",
    fileName: "myIncidents/travel.png",
  },
  {
    text: "Unrest",
    value: "unrest",
    fileName: "myIncidents/unrest.png",
  },
];

export const MY_INCIDENTS_CUSTOM_ICONS = [
  {
    text: "Ban",
    value: "ban",
    fileName: "myIncidents/ban.png",
  },
  {
    text: "Bolt",
    value: "bolt",
    fileName: "myIncidents/bolt.png",
  },
  {
    text: "Bug",
    value: "bug",
    fileName: "myIncidents/bug.png",
  },
  {
    text: "Car",
    value: "car",
    fileName: "myIncidents/car.png",
  },
  {
    text: "Crosshair",
    value: "crosshair",
    fileName: "myIncidents/crosshair.png",
  },
  {
    text: "Crowd",
    value: "crowd",
    fileName: "myIncidents/crowd.png",
  },
  {
    text: "Diamond",
    value: "diamond",
    fileName: "myIncidents/diamond.png",
  },
  {
    text: "Fire Extinguisher",
    value: "fireExtinguisher",
    fileName: "myIncidents/fireExtinguisher.png",
  },
  {
    text: "Flag",
    value: "flag",
    fileName: "myIncidents/flag.png",
  },
  {
    text: "Info",
    value: "info",
    fileName: "myIncidents/info.png",
  },
  {
    text: "Lock",
    value: "lock",
    fileName: "myIncidents/lock.png",
  },
  {
    text: "Medkit",
    value: "medkit",
    fileName: "myIncidents/medkit.png",
  },
  {
    text: "Question",
    value: "question",
    fileName: "myIncidents/question.png",
  },
  {
    text: "Road",
    value: "road",
    fileName: "myIncidents/road.png",
  },
  {
    text: "Rocket",
    value: "rocket",
    fileName: "myIncidents/rocket.png",
  },
  {
    text: "Snowflake",
    value: "snowflake",
    fileName: "myIncidents/snowflake.png",
  },
  {
    text: "Sun",
    value: "sun",
    fileName: "myIncidents/sun.png",
  },
  {
    text: "Times",
    value: "times",
    fileName: "myIncidents/times.png",
  },
  {
    text: "Truck",
    value: "truck",
    fileName: "myIncidents/truck.png",
  },
  {
    text: "Wrench",
    value: "wrench",
    fileName: "myIncidents/wrench.png",
  },
];

export const MY_INCIDENTS_TYPES_DESCRIPTION =
  "Title, description, category, date, location, and country are required fields";

export const MY_INCIDENTS_OPTIONAL_FIELDS_DESCRIPTION =
  "Enable optional fields";
export const MY_INCIDENTS_CUSTOM_FIELDS_DESCRIPTION =
  "Configure your custom fields";
